module.exports = __webpack_public_path__ + "img/h基础组件.841f70ce.svg";